const ITEMS = [
  'Sona Masoori Rice','Basmati Rice','HMT Rice','Ponni Rice',
  'Sunflower Oil','Groundnut Oil','Toor Dal','Chana Dal',
  'Red Chilli Powder','Turmeric','Wheat Flour','Iodized Salt',
  'Same-Day Delivery','GST Invoice','All Hyderabad','200+ Products',
];

export default function Ticker() {
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <div className="ticker" style={{ marginTop: 72 }}>
      <div className="ticker-inner">
        {doubled.map((item, i) => (
          <span key={i} className="tick-item">
            {item} <span className="tick-sep">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
